import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { Permissions } from '@utils/constants/permissions';
import { textCapitalize } from '@utils/helper/textConverter';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { eventListModels } from 'modules/event-list';

export function useActivityLogs() {
  const { i18n } = useTranslation();
  const permissions = useAppSelector(state => state?.userReducer?.user?.role?.permissions);
  const isActivityLogs = permissions?.includes(Permissions.PERMISSION_ACTIVITY_LOGS);

  const { data, ...arg } = useQuery<
    { activityLogs: eventListModels.IActivityLogTypes },
    unknown,
    Record<string, string>
  >({
    queryKey: ['dashboard-v2-activity-logs'],
    queryFn: async () => {
      const { data } = await $api.get('/v1/activity-logs');

      return { activityLogs: data.data };
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: isActivityLogs,
    select: ({ activityLogs }) =>
      [...(activityLogs?.actionTypeClient || []), ...(activityLogs?.actionType || [])]?.reduce<Record<string, string>>(
        (p, c) => {
          p[c?.name] =
            c[`name${textCapitalize(i18n.language)}` as keyof typeof c]?.toString().replace(/%s/gi, '') || '';
          return p;
        },
        {}
      )
  });

  return { activityLogs: data, ...arg };
}
